import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SntFilter } from 'src/app/pages/snt/snt-filters/snt-filters.model';

@Component({
  selector: 'app-product-select-snt-filters',
  templateUrl: './product-select-snt-filters.component.html',
  styleUrls: ['./product-select-snt-filters.component.scss'],
  standalone: false
})
export class ProductSelectSntFiltersComponent implements AfterViewInit {

  @Output() onFilter = new EventEmitter<SntFilter>();
  @Output() onClear = new EventEmitter();

  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.search();
  }

  initForm() {
    this.form = this.fb.group({
      number: this.fb.control(null),
      dateFrom: this.fb.control(''),
      dateTo: this.fb.control(''),
      registrationNumber: this.fb.control(null),
    });
  }

  clear() {
    this.form.get("number").setValue(null);
    this.form.get("dateFrom").setValue('');
    this.form.get("dateTo").setValue('');
    this.form.get("registrationNumber").setValue(null);
    this.onClear.emit();
  }

  search() {
    this.onFilter.emit(this.form.value as SntFilter);
  }
}
